export enum QuestionTypeEnum {
  SingleChoice = 'single_choice',
  MultipleChoice = 'multiple_choice',
  TrueOrFalse = 'true_or_false',
  FillInBlank = 'fill_in_blank',
  ShortAnswer = 'short_answer',
  Product = 'product',
}
